import { FunctionComponent } from 'react';
import { SUMainModal } from 'widgets/auth/signUp/_MainModal';

export const SignUp: FunctionComponent = () => {
	return <SUMainModal />;
};
